import { Component } from '@angular/core';
import { routeAnimations } from '../../shared/animations/router-animation';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
  animations: [routeAnimations]
})
export class SettingsComponent {

}
